var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fill: "inherit",
    d: "M27 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeWidth: 3,
    d: "M17 10a7 7 0 1 0 0 14 7 7 0 0 0 0-14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeWidth: 3,
    d: "M17 2c-4.074 0-4.584.017-6.184.09-1.597.073-2.687.327-3.642.698a7.352 7.352 0 0 0-2.656 1.73 7.35 7.35 0 0 0-1.73 2.656c-.371.955-.625 2.045-.698 3.642C2.017 12.416 2 12.926 2 17s.017 4.585.09 6.184c.073 1.597.327 2.687.698 3.642a7.353 7.353 0 0 0 1.73 2.656 7.352 7.352 0 0 0 2.656 1.73c.955.371 2.045.625 3.642.698 1.6.073 2.11.09 6.184.09s4.585-.017 6.184-.09c1.597-.073 2.687-.327 3.642-.698a7.352 7.352 0 0 0 2.656-1.73 7.354 7.354 0 0 0 1.73-2.656c.371-.955.625-2.045.698-3.642.073-1.6.09-2.11.09-6.184s-.017-4.585-.09-6.184c-.073-1.597-.327-2.687-.698-3.642a7.352 7.352 0 0 0-1.73-2.656 7.352 7.352 0 0 0-2.656-1.73c-.955-.371-2.045-.625-3.642-.698C21.584 2.017 21.074 2 17 2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.f1682a52859918febe935835178166f5.svg";
export { ForwardRef as ReactComponent };